import Reflux from 'reflux';

import listActions from '../actions/list-actions';

export default Reflux.createStore({
	init: function () {
		this.listenToMany(listActions);
		this._state = {
			isExpanded: null,
			standId: null,
			lastStandId: null,
		};
	},

	onExpand: function () {
		this._state.isExpanded = true;
		this.trigger(this._state);
	},

	onCollapse: function () {
		this._state.isExpanded = false;
		this.trigger(this._state);
	},

	onShowDetails: function (standId) {
		this._state.lastStandId = this._state.standId;
		this._state.standId = standId;
		this.trigger(this._state);
	},

	getInitialState: function () {
		return this._state;
	},
});
